import App from 'next/app';
import React from 'react';
import TagManager from 'react-gtm-module';
import { datadogRum } from '@datadog/browser-rum';
import Env from '../services/environment';

class MyApp extends App {
  componentDidMount() {
    TagManager.initialize({
      gtmId: 'GTM-MW2DT6H',
    });

    datadogRum.init({
      applicationId: Env.datadogAPIKey(),
      clientToken: Env.datadogClientToken(),
      datacenter: 'us',
      resourceSampleRate: 100,
      sampleRate: 100,
      silentMultipleInit: true,
    });
  }

  render() {
    const { Component, pageProps } = this.props;
    return <Component {...pageProps} />;
  }
}

export default MyApp;
